/* ============================================================
   The Poster Archive — Desenio-structured PDP
   Runs one instance per section. All product data is emitted by
   Liquid into the section's JSON script tag, so prices, SKUs and
   availability always come from Shopify — never hardcoded here.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ============================================================
     Gallery — deliberately standalone.

     This used to be bound inside TpaPdp, which bails out early if the product JSON
     payload is missing or unparseable. That coupling meant one unrelated failure took
     the image navigation down with it. The gallery now owns its own state and binds
     from the DOM alone, so the arrows keep working no matter what the rest of the
     section does. TpaPdp.setImage delegates here, so variant-driven image swaps and
     manual navigation share one source of truth.
     ============================================================ */

  function Gallery(root) {
    this.root = root;
    this.track = $('[data-tpa-track]', root);
    this.slides = $$('[data-tpa-slide-img]', root);
    this.dots = $$('[data-tpa-dot]', root);
    this.arrows = $$('[data-tpa-stage]', root);
    this.index = 0;
    if (!this.track || !this.slides.length) return;
    this.bind();
    this.set(0);
  }

  Gallery.prototype.bind = function () {
    var self = this;

    // Delegated on the stage, so arrows survive any re-render of their contents and a
    // click on the SVG inside the button still counts as a click on the button.
    var stage = $('[data-tpa-stage-el]', this.root) || this.root;
    stage.addEventListener('click', function (e) {
      var arrow = e.target.closest ? e.target.closest('[data-tpa-stage]') : null;
      if (arrow && stage.contains(arrow)) {
        e.preventDefault();
        self.step(parseInt(arrow.getAttribute('data-tpa-stage'), 10) || 1);
        return;
      }
      var dot = e.target.closest ? e.target.closest('[data-tpa-dot]') : null;
      if (dot) {
        e.preventDefault();
        self.set(parseInt(dot.getAttribute('data-tpa-dot'), 10) || 0);
      }
    });

    // Dots can sit outside the stage element depending on markup order.
    this.dots.forEach(function (d) {
      d.addEventListener('click', function (e) {
        e.preventDefault();
        self.set(parseInt(d.getAttribute('data-tpa-dot'), 10) || 0);
      });
    });

    // Keyboard: left/right arrows move the gallery while it has focus.
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); self.step(1); }
    });

    // Touch swipe.
    var x0 = null;
    this.track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    this.track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 44) self.step(dx < 0 ? 1 : -1);
      x0 = null;
    });
  };

  Gallery.prototype.step = function (d) {
    // Wrap around, so neither arrow is ever a dead end on a multi-image product.
    var n = this.slides.length;
    this.set(((this.index + d) % n + n) % n);
  };

  Gallery.prototype.set = function (i) {
    var n = this.slides.length;
    if (!n) return;
    this.index = Math.max(0, Math.min(n - 1, i));
    this.track.style.transform = 'translateX(-' + (this.index * 100) + '%)';
    var self = this;
    this.dots.forEach(function (d) {
      d.setAttribute('aria-current', parseInt(d.getAttribute('data-tpa-dot'), 10) === self.index ? 'true' : 'false');
    });
    // Arrows wrap, so they are never disabled while more than one image exists.
    this.arrows.forEach(function (a) { a.disabled = n < 2; });
  };

  function TpaPdp(root) {
    this.root = root;
    var dataEl = $('[data-tpa-data]', root);
    if (!dataEl) return;
    try { this.data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    // Belt and braces: a template saved before this label existed would omit it.
    this.data.labels = this.data.labels || {};
    if (!this.data.labels.unavailable) this.data.labels.unavailable = 'Unavailable';
    if (!this.data.variants || !this.data.variants.length) return;

    this.state = {
      format: null,
      size: null,
      frame: null,
      unit: 'in',
      image: 0,
      guideIndex: 0
    };

    this.gallery = root.tpaGallery || null;
    this.cacheNodes();
    this.seedFromCurrentVariant();
    this.bind();
    this.setImage(0);
    this.render();
    this.renderGuide();
  }

  TpaPdp.prototype.cacheNodes = function () {
    var r = this.root;
    this.el = {
      track: $('[data-tpa-track]', r),
      dots: $$('[data-tpa-dot]', r),
      slides: $$('[data-tpa-slide-img]', r),
      priceNow: $('[data-tpa-price-now]', r),
      priceWas: $('[data-tpa-price-was]', r),
      badge: $('[data-tpa-badge]', r),
      formatBtns: $$('[data-tpa-format]', r),
      priceUnframed: $('[data-tpa-price-unframed]', r),
      priceFramed: $('[data-tpa-price-framed]', r),
      sizeSelect: $('[data-tpa-select]', r),
      sizeButton: $('[data-tpa-select-button]', r),
      sizeListbox: $('[data-tpa-listbox]', r),
      sizeLabel: $('[data-tpa-size-label]', r),
      sizePrice: $('[data-tpa-size-price]', r),
      stageEl: $('[data-tpa-stage-el]', r),
      frameOpt: $('[data-tpa-frame-opt]', r),
      frameScroll: $('[data-tpa-frame-scroll]', r),
      frameArrows: $$('[data-tpa-frame-arrow]', r),
      unitBtns: $$('[data-tpa-unit]', r),
      qty: $('[data-tpa-qty-input]', r),
      atc: $('[data-tpa-atc]', r),
      atcPrice: $('[data-tpa-atc-price]', r),
      atcLabel: $('[data-tpa-atc-label]', r),
      variantInput: $('[data-tpa-variant-id]', r),
      form: $('[data-tpa-form]', r),
      sku: $('[data-tpa-sku]', r),
      skuRow: $('[data-tpa-sku-row]', r),
      sticky: $('[data-tpa-sticky]', r),
      stickyMeta: $('[data-tpa-sticky-meta]', r),
      stickyPrice: $('[data-tpa-sticky-price]', r),
      stickyCtaPrice: $('[data-tpa-sticky-ctaprice]', r),
      buyrow: $('[data-tpa-buyrow]', r),
      guide: $('[data-tpa-guide]', r),
      guidePoster: $('[data-tpa-guide-poster]', r),
      guidePosterImg: $('[data-tpa-guide-poster-img]', r),
      guideLabel: $('[data-tpa-guide-label]', r),
      guideLinks: $('[data-tpa-guide-links]', r),
      guideNavs: $$('[data-tpa-guide-nav]', r),
      lightbox: $('[data-tpa-lightbox]', r),
      lightboxImg: $('[data-tpa-lightbox-img]', r),
      lightboxCount: $('[data-tpa-lightbox-count]', r),
      lightboxPrice: $('[data-tpa-lightbox-price]', r),
      toast: $('[data-tpa-toast]', r),
      toastMeta: $('[data-tpa-toast-meta]', r),
      toastImg: $('[data-tpa-toast-img]', r)
    };
  };

  /* ---------------- data helpers ---------------- */

  TpaPdp.prototype.seedFromCurrentVariant = function () {
    var d = this.data;
    var v = null, i;
    for (i = 0; i < d.variants.length; i++) {
      if (d.variants[i].id === d.currentVariantId) { v = d.variants[i]; break; }
    }
    if (!v) {
      for (i = 0; i < d.variants.length; i++) { if (d.variants[i].available) { v = d.variants[i]; break; } }
    }
    if (!v) v = d.variants[0];
    this.state.format = v.opts.format || null;
    this.state.size = v.opts.size || null;
    this.state.frame = v.opts.frame || null;
  };

  TpaPdp.prototype.findVariant = function (format, size, frame) {
    var vs = this.data.variants, i, v;
    for (i = 0; i < vs.length; i++) {
      v = vs[i];
      if (this.data.hasFormat && v.opts.format !== format) continue;
      if (this.data.hasSize && v.opts.size !== size) continue;
      if (this.data.hasFrame && v.opts.frame !== frame) continue;
      return v;
    }
    return null;
  };

  /* Strict lookup for per-option UI. `resolve` below deliberately relaxes the axes it
     wasn't asked about, which is right for choosing an initial variant but WRONG for
     rendering a per-option list: if the shopper has Framed selected and no framed
     variant exists in 20x20, the relaxed match returns the 24x24 framed variant and the
     20x20 row would print that variant's price, showing two different sizes at the same
     price and no sold-out marker. Option lists must use exact matching and show an
     unavailable state when the combination genuinely does not exist. */
  TpaPdp.prototype.exact = function (format, size, frame) {
    return this.findVariant(format, size, frame);
  };

  // Nearest match: keep the requested axis, relax the others toward something available.
  TpaPdp.prototype.resolve = function (format, size, frame) {
    var v = this.findVariant(format, size, frame);
    if (v) return v;
    var vs = this.data.variants, i, best = null;
    for (i = 0; i < vs.length; i++) {
      var c = vs[i], score = 0;
      if (!this.data.hasFormat || c.opts.format === format) score += 4;
      if (!this.data.hasSize || c.opts.size === size) score += 2;
      if (!this.data.hasFrame || c.opts.frame === frame) score += 1;
      if (c.available) score += 0.5;
      if (!best || score > best.score) best = { v: c, score: score };
    }
    return best ? best.v : vs[0];
  };

  TpaPdp.prototype.current = function () {
    var v = this.resolve(this.state.format, this.state.size, this.state.frame);
    if (v) {
      this.state.format = v.opts.format || this.state.format;
      this.state.size = v.opts.size || this.state.size;
      this.state.frame = v.opts.frame || this.state.frame;
    }
    return v;
  };

  TpaPdp.prototype.sizeMeta = function (value) {
    var s = this.data.sizes, i;
    for (i = 0; i < s.length; i++) { if (s[i].value === value) return s[i]; }
    return s[0] || null;
  };

  TpaPdp.prototype.sizeText = function (s) {
    if (!s) return '';
    if (this.state.unit === 'cm' && s.cm) return s.cm;
    return s['in'] || s.value;
  };

  TpaPdp.prototype.altText = function (s) {
    if (!s) return '';
    return this.state.unit === 'cm' ? (s['in'] || '') : (s.cm || '');
  };

  TpaPdp.prototype.isFramed = function () {
    return this.data.hasFormat && this.state.format === this.data.formats.framed;
  };

  TpaPdp.prototype.metaLine = function () {
    var parts = [];
    if (this.data.hasSize) parts.push(this.sizeText(this.sizeMeta(this.state.size)));
    if (this.data.hasFormat) {
      parts.push(this.isFramed()
        ? (this.data.hasFrame && this.state.frame ? this.state.frame + ' ' + this.data.labels.frameWord : this.data.labels.framedShort)
        : this.data.labels.unframedShort);
    } else if (this.data.hasFrame && this.state.frame) {
      parts.push(this.state.frame);
    }
    return parts.join(' · ');
  };

  /* ---------------- bindings ---------------- */

  TpaPdp.prototype.bind = function () {
    var self = this;
    var el = this.el;

    // format toggle
    el.formatBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var next = b.getAttribute('data-tpa-format');
        self.state.format = next;
        if (self.data.hasFrame) {
          if (next === self.data.formats.framed && self.state.frame === self.data.frameNone) {
            self.state.frame = self.data.firstFrame;
          }
          if (next === self.data.formats.unframed) self.state.frame = self.data.frameNone;
        }
        self.render();
      });
    });

    // size listbox
    if (el.sizeButton) {
      el.sizeButton.addEventListener('click', function (e) {
        e.stopPropagation();
        el.sizeSelect.getAttribute('data-open') === 'true' ? self.closeListbox() : self.openListbox();
      });
    }
    $$('[data-tpa-close-listbox]', this.root).forEach(function (b) {
      b.addEventListener('click', function () { self.closeListbox(); });
    });
    document.addEventListener('click', function (e) {
      if (el.sizeSelect && !el.sizeSelect.contains(e.target)) self.closeListbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { self.closeListbox(); self.closeModals(); self.hideToast(); }
    });

    // units
    el.unitBtns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        self.state.unit = b.getAttribute('data-tpa-unit');
        self.render();
        self.renderGuide();
      });
    });

    // frame scroll arrows
    el.frameArrows.forEach(function (a) {
      a.addEventListener('click', function () {
        el.frameScroll.scrollBy({ left: a.getAttribute('data-tpa-frame-arrow') === 'next' ? 220 : -220, behavior: 'smooth' });
      });
    });

    // quantity
    $$('[data-tpa-qty]', this.root).forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-tpa-qty'), 10);
        el.qty.value = Math.max(1, (parseInt(el.qty.value, 10) || 1) + step);
      });
    });

    // Gallery navigation (arrows, dots, swipe, keyboard) is owned by the standalone
    // Gallery instance created at boot, so it is not re-bound here.
    var wish = $('[data-tpa-wish]', this.root);
    if (wish) {
      wish.addEventListener('click', function () {
        this.setAttribute('aria-pressed', this.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      });
    }

    // lightbox
    el.slides.forEach(function (img, i) {
      img.addEventListener('click', function () { self.openLightbox(i); });
    });
    $$('[data-tpa-lb]', this.root).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (self.state.image + parseInt(b.getAttribute('data-tpa-lb'), 10) + el.slides.length) % el.slides.length;
        self.openLightbox(n);
        self.setImage(n);
      });
    });

    // size guide
    $$('[data-tpa-open-guide]', this.root).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        self.closeListbox();
        var sizes = self.data.sizes;
        for (var i = 0; i < sizes.length; i++) { if (sizes[i].value === self.state.size) self.state.guideIndex = i; }
        self.renderGuide();
        self.openModal(el.guide);
      });
    });
    el.guideNavs.forEach(function (b) {
      b.addEventListener('click', function () {
        var next = self.state.guideIndex + parseInt(b.getAttribute('data-tpa-guide-nav'), 10);
        if (next < 0 || next > self.data.sizes.length - 1) return;
        self.state.guideIndex = next;
        self.state.size = self.data.sizes[next].value;
        self.renderGuide();
        self.render();
      });
    });
    $$('[data-tpa-close-modal]', this.root).forEach(function (b) {
      b.addEventListener('click', function () { self.closeModals(); });
    });

    // sticky bar
    if (el.sticky && el.buyrow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        el.sticky.setAttribute('data-visible', past ? 'true' : 'false');
      }, { threshold: 0 }).observe(el.buyrow);
    }

    // add to cart
    $$('[data-tpa-atc], [data-tpa-sticky-atc]', this.root).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        self.addToCart(b);
      });
    });
    if (el.form) {
      el.form.addEventListener('submit', function (e) { e.preventDefault(); self.addToCart(el.atc); });
    }
    $$('[data-tpa-close-toast]', this.root).forEach(function (b) {
      b.addEventListener('click', function () { self.hideToast(); });
    });
  };

  /* ---------------- listbox ---------------- */

  TpaPdp.prototype.openListbox = function () {
    if (!this.el.sizeSelect) return;
    this.el.sizeSelect.setAttribute('data-open', 'true');
    this.el.sizeButton.setAttribute('aria-expanded', 'true');
  };
  TpaPdp.prototype.closeListbox = function () {
    if (!this.el.sizeSelect) return;
    this.el.sizeSelect.setAttribute('data-open', 'false');
    this.el.sizeButton.setAttribute('aria-expanded', 'false');
  };

  TpaPdp.prototype.renderSizeOptions = function () {
    var self = this;
    var box = this.el.sizeListbox;
    if (!box) return;
    $$('.tpa-listbox__item', box).forEach(function (n) { n.remove(); });
    var foot = $('.tpa-listbox__foot', box);
    this.data.sizes.forEach(function (s) {
      var v = self.exact(self.state.format, s.value, self.state.frame);
      var missing = !v;
      var blocked = missing || !v.available;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tpa-listbox__item';
      btn.setAttribute('role', 'option');
      btn.setAttribute('aria-selected', s.value === self.state.size ? 'true' : 'false');
      if (blocked) btn.setAttribute('aria-disabled', 'true');
      var price = v ? '<b>' + v.price + '</b>' + (v.onSale ? '<s>' + v.compare + '</s>' : '') : '';
      var soldout = blocked
        ? ' <span class="tpa-soldout">' + (missing ? self.data.labels.unavailable : self.data.labels.soldOut) + '</span>'
        : '';
      btn.innerHTML =
        '<span><span>' + self.sizeText(s) + '</span> ' +
        '<span class="tpa-li-dim">' + self.altText(s) + '</span>' + soldout + '</span>' +
        '<span class="tpa-li-price">' + price + '</span>';
      btn.addEventListener('click', function () {
        if (blocked) return;
        self.state.size = s.value;
        self.closeListbox();
        self.render();
      });
      box.insertBefore(btn, foot);
    });
  };

  /* ---------------- frames ---------------- */

  /* Frame value (e.g. "Natural Wood") -> visual family used by the CSS. */
  TpaPdp.prototype.frameChip = function (value) {
    var frames = this.data.frames || [];
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].value === value) return frames[i].chip;
    }
    return '';
  };

  TpaPdp.prototype.renderFrames = function () {
    var self = this;
    var wrap = this.el.frameScroll;
    if (!wrap) return;
    wrap.innerHTML = '';
    this.data.frames.forEach(function (f) {
      var v = self.exact(self.data.formats.framed, self.state.size, f.value);
      var missing = !v;
      var blocked = missing || !v.available;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tpa-swatch';
      btn.setAttribute('aria-pressed', f.value === self.state.frame ? 'true' : 'false');
      if (blocked) btn.setAttribute('aria-disabled', 'true');
      /* Prefer a real thumbnail of this poster in that frame; the flat colour chip
         is only used when the product has no image at all. */
      var visual;
      if (self.data.artThumb) {
        visual =
          '<span class="tpa-swatch__thumb tpa-swatch__thumb--' + f.chip + '">' +
            '<img src="' + self.data.artThumb + '" alt="" width="58" height="58" loading="lazy">' +
          '</span>';
      } else {
        visual =
          '<span class="tpa-swatch__chip tpa-swatch__chip--' + f.chip + '"' +
            (f.swatchColor ? ' style="background:' + f.swatchColor + '"' : '') + '></span>';
      }
      btn.innerHTML =
        visual +
        '<span class="tpa-swatch__name">' + f.value + '</span>' +
        '<span class="tpa-swatch__delta">' +
          (blocked ? (missing ? self.data.labels.unavailable : self.data.labels.soldOut) : self.data.labels.frameIncluded) +
        '</span>';
      btn.addEventListener('click', function () {
        if (blocked) return;
        self.state.frame = f.value;
        if (self.data.hasFormat) self.state.format = self.data.formats.framed;
        self.render();
      });
      wrap.appendChild(btn);
    });
    var over = wrap.scrollWidth > wrap.clientWidth + 4;
    this.el.frameArrows.forEach(function (a) { a.hidden = !over; });
  };

  /* ---------------- gallery ---------------- */

  // Delegates to the standalone Gallery so variant-driven image swaps and the arrows
  // cannot disagree about which image is showing.
  TpaPdp.prototype.setImage = function (i) {
    var g = this.gallery || this.root.tpaGallery;
    if (!g) return;
    g.set(i);
    this.state.image = g.index;
  };

  TpaPdp.prototype.openLightbox = function (i) {
    var el = this.el;
    if (!el.lightbox) return;
    this.state.image = i;
    el.lightboxImg.src = el.slides[i].getAttribute('data-tpa-full') || el.slides[i].src;
    el.lightboxImg.alt = el.slides[i].alt;
    if (el.lightboxCount) el.lightboxCount.textContent = (i + 1) + ' / ' + el.slides.length;
    this.openModal(el.lightbox);
  };

  /* ---------------- modals ---------------- */

  TpaPdp.prototype.openModal = function (m) {
    if (!m) return;
    m.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  };
  TpaPdp.prototype.closeModals = function () {
    $$('.tpa-modal', this.root).forEach(function (m) { m.setAttribute('data-open', 'false'); });
    document.body.style.overflow = '';
  };

  /* ---------------- size guide ---------------- */

  TpaPdp.prototype.renderGuide = function () {
    var self = this;
    var el = this.el;
    if (!el.guide || !this.data.sizes.length) return;

    if (el.guideLinks && !el.guideLinks.getAttribute('data-built')) {
      this.data.sizes.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.addEventListener('click', function () {
          self.state.guideIndex = i;
          self.state.size = s.value;
          self.renderGuide();
          self.render();
        });
        el.guideLinks.appendChild(b);
      });
      el.guideLinks.setAttribute('data-built', 'true');
    }

    var s = this.data.sizes[this.state.guideIndex] || this.data.sizes[0];
    var pxPerInch = this.data.guidePersonPx / this.data.personIn;
    if (s.w && s.h) {
      el.guidePoster.style.width = (s.w * pxPerInch) + 'px';
      el.guidePoster.style.height = (s.h * pxPerInch) + 'px';
    }
    if (el.guideLabel) el.guideLabel.textContent = this.sizeText(s);
    if (el.guideLinks) {
      $$('button', el.guideLinks).forEach(function (b, i) {
        b.setAttribute('aria-current', i === self.state.guideIndex ? 'true' : 'false');
        b.textContent = self.sizeText(self.data.sizes[i]);
      });
    }
    el.guideNavs.forEach(function (b) {
      var dir = parseInt(b.getAttribute('data-tpa-guide-nav'), 10);
      b.disabled = dir < 0 ? self.state.guideIndex === 0 : self.state.guideIndex === self.data.sizes.length - 1;
    });
  };

  /* ---------------- cart ---------------- */

  TpaPdp.prototype.addToCart = function (btn) {
    var self = this;
    var v = this.current();
    if (!v || !v.available) return;
    var qty = parseInt(this.el.qty ? this.el.qty.value : 1, 10) || 1;
    if (btn) btn.classList.add('is-loading');

    // Horizon's cart drawer needs server-rendered HTML for every cart-items section.
    // Request those sections as part of the add operation so the drawer can morph
    // synchronously instead of opening on its stale pre-add markup.
    var sectionIds = [];
    Array.prototype.forEach.call(document.querySelectorAll('cart-items-component'), function (item) {
      var sectionId = item instanceof HTMLElement ? item.dataset.sectionId : '';
      if (sectionId && sectionIds.indexOf(sectionId) === -1) sectionIds.push(sectionId);
    });
    var formData = new FormData();
    formData.append('id', String(v.id));
    formData.append('quantity', String(qty));
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, json: j }; }); })
      .then(function (r) {
        if (btn) btn.classList.remove('is-loading');
        if (!r.ok) {
          if (self.el.form) self.el.form.submit();
          return;
        }
        self.notifyTheme(v, qty, r.json && r.json.sections);
      })
      .catch(function () {
        if (btn) btn.classList.remove('is-loading');
        if (self.el.form) self.el.form.submit();
      });
  };

  /*
   * Tell the theme a line was added, then decide who confirms it.
   * The theme's cart components listen on `cart:update` and read
   * `event.detail.data.sections` — so the detail shape below is required, or their
   * handler throws and the drawer renders a stale state. The add request supplies
   * the rendered section map, allowing Horizon to replace the drawer contents
   * during the same cart:update event. If a cart drawer is present and set to auto-open, it is
   * the confirmation and we stay out of the way; otherwise we show our own toast.
   */
  TpaPdp.prototype.notifyTheme = function (v, qty, sections) {
    var self = this;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var dispatch = function (cart) {
      var detail = {
        resource: cart || null,
        sourceId: 'tpa-desenio-pdp',
        data: {
          source: 'tpa-desenio-pdp',
          itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : undefined,
          variantId: String(v.id),
          sections: sections || {}
        }
      };
      try {
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = detail;
        document.dispatchEvent(ev);
      } catch (e) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
      }

      var drawer = document.querySelector('cart-drawer-component[auto-open]');
      if (!drawer) self.showToast(v, qty);
    };

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(dispatch)
      .catch(function () { dispatch(null); });
  };

  TpaPdp.prototype.showToast = function (v, qty) {
    var el = this.el;
    if (!el.toast) return;
    if (el.toastMeta) {
      el.toastMeta.textContent = this.metaLine() + ' · ' + v.price + (qty > 1 ? ' × ' + qty : '');
    }
    if (el.toastImg && el.slides.length) el.toastImg.src = el.slides[0].src;
    el.toast.setAttribute('data-open', 'true');
    var self = this;
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(function () { self.hideToast(); }, 7000);
  };
  TpaPdp.prototype.hideToast = function () {
    if (this.el.toast) this.el.toast.setAttribute('data-open', 'false');
  };

  /* ---------------- render ---------------- */

  TpaPdp.prototype.render = function () {
    var el = this.el;
    var self = this;
    var v = this.current();
    if (!v) return;
    var s = this.data.hasSize ? this.sizeMeta(this.state.size) : null;

    if (el.priceNow) el.priceNow.textContent = v.price;
    if (el.priceWas) {
      el.priceWas.textContent = v.onSale ? v.compare : '';
      el.priceWas.hidden = !v.onSale;
    }
    if (el.badge) {
      el.badge.hidden = !(v.onSale && v.savePercent);
      if (v.onSale && v.savePercent) el.badge.textContent = this.data.labels.savePrefix + ' ' + v.savePercent + '%';
    }

    if (el.sizeLabel && s) el.sizeLabel.textContent = this.sizeText(s);
    if (el.sizePrice) el.sizePrice.textContent = v.price;

    if (el.sku) el.sku.textContent = v.sku || '';
    if (el.skuRow) el.skuRow.hidden = !v.sku;

    if (el.atcPrice) el.atcPrice.textContent = '— ' + v.price;
    if (el.atc) {
      el.atc.disabled = !v.available;
      if (el.atcLabel) el.atcLabel.textContent = v.available ? this.data.labels.addToCart : this.data.labels.soldOut;
    }
    if (el.variantInput) el.variantInput.value = v.id;
    if (el.lightboxPrice) el.lightboxPrice.textContent = v.price;

    if (el.priceUnframed) {
      var u = this.resolve(this.data.formats.unframed, this.state.size, this.data.frameNone);
      el.priceUnframed.textContent = u ? u.price : '';
    }
    if (el.priceFramed) {
      var f = this.resolve(this.data.formats.framed, this.state.size, this.data.firstFrame);
      el.priceFramed.textContent = f ? f.price : '';
    }

    el.formatBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-tpa-format') === self.state.format ? 'true' : 'false');
    });
    if (el.frameOpt) el.frameOpt.hidden = this.data.hasFormat ? !this.isFramed() : false;

    el.unitBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-tpa-unit') === self.state.unit ? 'true' : 'false');
    });

    if (el.stickyMeta) el.stickyMeta.textContent = this.metaLine();
    if (el.stickyPrice) el.stickyPrice.innerHTML = v.price + (v.onSale ? ' <s>' + v.compare + '</s>' : '');
    if (el.stickyCtaPrice) el.stickyCtaPrice.textContent = v.price;

    // swap the main image if this variant has its own media
    if (v.mediaIndex !== null && v.mediaIndex !== undefined && v.mediaIndex !== this.state.image) {
      this.setImage(v.mediaIndex);
    }

    /* Frame the artwork in the gallery to match the selection. Real per-variant
       photography (handled just above) always takes priority; this composites a
       frame for products that only have flat art, so the picture visibly changes
       when the shopper picks Framed and switches frame colour. */
    if (el.stageEl) {
      // Products that offer frames without a separate format option count as framed
      // whenever the chosen frame isn't the "no frame" value.
      var framed = this.data.hasFormat
        ? this.isFramed()
        : !!(this.data.hasFrame && this.state.frame && this.state.frame !== this.data.frameNone);
      el.stageEl.setAttribute('data-framed', framed ? 'true' : 'false');
      el.stageEl.setAttribute('data-frame', framed ? this.frameChip(this.state.frame) : '');
    }

    this.renderSizeOptions();
    this.renderFrames();
    if (el.guide && el.guide.getAttribute('data-open') === 'true') this.renderGuide();
  };

  /* ---------------- boot ---------------- */

  function init() {
    $$('[data-tpa-pdp]').forEach(function (root) {
      if (root.getAttribute('data-tpa-ready')) return;
      root.setAttribute('data-tpa-ready', '1');
      // Gallery first, and in its own try/catch, so image navigation is live even if
      // the buy box fails to initialise for any reason.
      try {
        root.tpaGallery = new Gallery(root);
      } catch (e) {
        if (window.console && console.warn) console.warn('[tpa] gallery init failed', e);
      }
      try {
        new TpaPdp(root);
      } catch (e) {
        if (window.console && console.warn) console.warn('[tpa] pdp init failed', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme Editor re-renders sections without a page reload
  document.addEventListener('shopify:section:load', init);
})();
